import Vue from 'vue'
import vuetify from './plugins/vuetify';

import App from './App.vue'
import Router from './router'
import { store } from './store/store'

import Amplify from 'aws-amplify';


import { Hub, Logger } from 'aws-amplify';

const logger = new Logger('My-Logger');

const listener = (data) => {
    switch (data.payload.event) {
        case 'signIn':
            logger.info('user signed in');
            store.commit('setLoggedIn', true);
            break;
        case 'signUp':
            logger.info('user signed up');
            break;
        case 'signOut':
            logger.info('user signed out');
            store.commit('setLoggedIn', false);
            break;
        case 'signIn_failure':
            logger.error('user sign in failed');
            store.commit('setLoggedIn', false);
            break;
        case 'tokenRefresh':
            logger.info('token refresh succeeded');
            store.commit('setLoggedIn', true);
            break;
        case 'tokenRefresh_failure':
            logger.error('token refresh failed');
            store.commit('setLoggedIn', false);
            break;
        case 'configured':
            logger.info('the Auth module is configured');
    }
}

Hub.listen('auth', listener);
Vue.config.productionTip = false


Amplify.configure({
    // OPTIONAL - if your API requires authentication 
    Auth: {
        // REQUIRED - Amazon Cognito Identity Pool ID
        // identityPoolId: 'XX-XXXX-X:XXXXXXXX-XXXX-1234-abcd-1234567890ab',
        // REQUIRED - Amazon Cognito Region
        region: 'ca-central-1', 
        // OPTIONAL - Amazon Cognito User Pool ID
        userPoolId: 'ca-central-1_jS3nJ2L5v', 
        // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
        userPoolWebClientId: '4cnef84qva9doiobfmmcspasq4',
    }
});

export const bus = new Vue();

new Vue({
  vuetify,
  store: store,
  router: Router,
  render: h => h(App)
}).$mount('#app')
